export const TEST_ID = 'mapDropdownItem';
